const getDeliveryZone = () => window.VitalReception.zone();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.initCameroonBeneficiaryFields();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      initCameroonBeneficiaryFields() {
        this.cameroonForm = this.form.querySelector('[data-cameroon-beneficiary-form]');
        if (!this.cameroonForm) return;

        this.cameroonMethodRadios = [...this.cameroonForm.querySelectorAll('[data-cameroon-method]')];
        this.cameroonCommonFields = [...this.cameroonForm.querySelectorAll('[data-cameroon-field]:not([data-cameroon-method])')];
        this.cameroonMethodSections = {
          local: [...this.cameroonForm.querySelectorAll('[data-cameroon-when-method="local"]')],
          pickup: [...this.cameroonForm.querySelectorAll('[data-cameroon-when-method="pickup"]')],
        };
        this.deliveryZoneField = this.cameroonForm.querySelector('[name="properties[_Delivery Zone]"]');
        this.methodError = this.cameroonForm.querySelector('#CameroonReceptionMethodError-' + this.getFormSectionId());
        this.beneficiaryName = this.cameroonForm.querySelector('[name="properties[Beneficiary full name]"]');
        this.beneficiaryPhone = this.cameroonForm.querySelector('[name="properties[Beneficiary phone]"]');
        this.beneficiaryCity = this.cameroonForm.querySelector('[name="properties[Beneficiary city]"]');
        this.beneficiaryDistrict = this.cameroonForm.querySelector('[name="properties[Beneficiary district]"]');
        this.deliveryDetails = this.cameroonForm.querySelector('[name="properties[Delivery details]"]');
        this.pickupPerson = this.cameroonForm.querySelector('[name="properties[Pickup person]"]');
        this.pickupNotes = this.cameroonForm.querySelector('[name="properties[Pickup notes]"]');
        this.messageForBeneficiary = this.cameroonForm.querySelector('[name="properties[Message for beneficiary]"]');

        this.form.addEventListener('change', this.onCameroonFormChange.bind(this));
        this._diasporaHandler = this.updateCameroonBeneficiaryFields.bind(this);
        document.addEventListener('diaspora:delivery-zone-selected', this._diasporaHandler);
        document.addEventListener('DOMContentLoaded', this._diasporaHandler);
        this.updateCameroonBeneficiaryFields();
      }

      getFormSectionId() {
        return this.form.getAttribute('id') || '';
      }

      onCameroonFormChange(event) {
        if (!event.target.closest('[data-cameroon-beneficiary-form]')) return;

        if (event.target.matches('[data-cameroon-method]')) {
          this.updateCameroonBeneficiaryFields();
          if (this.methodError) {
            this.methodError.hidden = true;
          }
        }
      }

      updateCameroonBeneficiaryFields() {
        if (!this.cameroonForm) {
          return;
        }

        const zoneIsCameroon = getDeliveryZone() === 'CM';
        this.cameroonForm.hidden = !zoneIsCameroon;

        this.cameroonMethodRadios.forEach((radio) => {
          radio.disabled = !zoneIsCameroon;
        });

        const selectedMethod = this.cameroonMethodRadios.find((radio) => radio.checked)?.dataset.cameroonMethod || null;

        this.cameroonCommonFields.forEach((field) => {
          const required = field.dataset.cameroonRequired === 'true' && zoneIsCameroon;
          field.disabled = !zoneIsCameroon;
          field.required = required;
          if (!required) {
            field.removeAttribute('aria-invalid');
          }
        });

        Object.entries(this.cameroonMethodSections).forEach(([method, sections]) => {
          const show = zoneIsCameroon && selectedMethod === method;
          sections.forEach((section) => {
            section.hidden = !show;
            section.querySelectorAll('[data-cameroon-field]').forEach((field) => {
              const required = field.dataset.cameroonRequired === 'true' && show;
              field.disabled = !show;
              field.required = required;
              if (!required) {
                field.removeAttribute('aria-invalid');
              }
            });
          });
        });

        if (this.deliveryZoneField) {
          this.deliveryZoneField.disabled = false;
          this.deliveryZoneField.value = zoneIsCameroon ? 'CM' : 'EU';
        }
      }

      clearCameroonErrors() {
        if (!this.cameroonForm) return;

        const errors = this.cameroonForm.querySelectorAll('.product-form__cameroon-field-message');
        errors.forEach((message) => {
          message.hidden = true;
          message.textContent = '';
        });

        const invalidFields = this.cameroonForm.querySelectorAll('[aria-invalid="true"]');
        invalidFields.forEach((field) => field.removeAttribute('aria-invalid'));
      }

      setCameroonFieldError(field, message) {
        if (!field) return;

        let errorMessage = null;
        if (field.matches('.product-form__cameroon-field-message')) {
          errorMessage = field;
        } else {
          const errorId = field.getAttribute('aria-describedby');
          errorMessage = errorId ? document.getElementById(errorId) : null;
        }

        if (!errorMessage) {
          const fallbackField = field.closest('fieldset') || field.closest('[data-cameroon-beneficiary-form]');
          errorMessage = fallbackField ? fallbackField.querySelector('.product-form__cameroon-field-message') : null;
        }

        if (errorMessage) {
          errorMessage.textContent = message;
          errorMessage.hidden = false;
        }

        if (!field.matches('.product-form__cameroon-field-message')) {
          field.setAttribute('aria-invalid', 'true');
        }
      }

      validateCameroonBeneficiaryFields() {
        if (getDeliveryZone() === 'CM' && !this.cameroonForm) {
          window.openDiasporaModal?.(this.submitButton);
          return false;
        }
        if (!this.cameroonForm || this.cameroonForm.hidden) {
          return true;
        }

        this.clearCameroonErrors();

        let firstInvalidField = null;
        const selectedMethod = this.cameroonMethodRadios.find((radio) => radio.checked)?.dataset.cameroonMethod;

        if (!selectedMethod) {
          const radio = this.cameroonMethodRadios[0];
          firstInvalidField = firstInvalidField || radio;
          this.setCameroonFieldError(
            this.methodError || radio,
            this.methodError?.dataset.errorMessage || 'Please choose Local delivery or Pickup before adding to cart.'
          );
        }

        const checks = [
          { field: this.beneficiaryName, message: window.theme && theme.translations ? theme.translations['cameroon_beneficiary.required'] || 'This field is required.' : 'This field is required.' },
          { field: this.beneficiaryPhone, message: window.theme && theme.translations ? theme.translations['cameroon_beneficiary.phone.required'] || 'Please enter a phone or WhatsApp number.' : 'Please enter a phone or WhatsApp number.' },
          { field: this.beneficiaryCity, message: window.theme && theme.translations ? theme.translations['cameroon_beneficiary.city.required'] || 'Please enter a city.' : 'Please enter a city.' },
        ];

        checks.forEach(({ field, message }) => {
          if (field && field.required && !field.value.trim()) {
            if (!firstInvalidField) firstInvalidField = field;
            this.setCameroonFieldError(field, message);
          }
        });

        if (selectedMethod === 'local' && this.beneficiaryDistrict && this.beneficiaryDistrict.required && !this.beneficiaryDistrict.value.trim()) {
          if (!firstInvalidField) firstInvalidField = this.beneficiaryDistrict;
          this.setCameroonFieldError(
            this.beneficiaryDistrict,
            window.theme && theme.translations ? theme.translations['cameroon_beneficiary.district.required'] || 'Please enter a district or neighbourhood for local delivery.' : 'Please enter a district or neighbourhood for local delivery.'
          );
        }

        if (firstInvalidField) {
          firstInvalidField.focus();
          return false;
        }

        return true;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.receptionChecking || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.receptionChecking = true;
        let allowed;
        try { allowed = await window.VitalReception.guard(getDeliveryZone(), this); }
        finally { this.receptionChecking = false; }
        if (!allowed) return;
        this.updateCameroonBeneficiaryFields();
        if (!this.validateCameroonBeneficiaryFields()) {
          evt.preventDefault();
          return;
        }

        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.set('properties[_Delivery Zone]', getDeliveryZone());
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
      
      disconnectedCallback() {
        if (this._diasporaHandler) {
          document.removeEventListener('diaspora:delivery-zone-selected', this._diasporaHandler);
          document.removeEventListener('DOMContentLoaded', this._diasporaHandler);
        }
      }
    }
  );
}
